import firebase from 'firebase'
import Fuse from 'fuse-js-latest'
import { event } from 'vue-analytics'
import moment from 'moment'

const DATEFORMAT = "ddd, MMM D h:mmA"

export default {
    state: {    
      isSyncedMessages: false,
      messagesortorder: 'desc',  
      memberMessagesDocs: [],
      groupMessagesDocs: [],
      groupOwnerMessagesDocs: [],
      lineMessagesDocs: [],
      messagesdocTemplate:{
          docid: null,
          org: null,
          chapter: null,
          chatname: null,
          ismemberchat: null,
          isgroupchat: null,
          islinechat: null,
          ownerid: null,
          ownername: null,
          ownerline: null,
          owneravatar: null,
          //lineidvalue: true,
          //useridvalue: true,
          participants: [],
          participantnames: [],
          datelastmessage: null,
          lastmessage: null, 
          lastmessageauthor: null,         
          messages: []
      },
      messageTemplate: {
          datecreated: null,
          authorid: null,
          authorname: null,
          authorline: null,
          authoravatar: null,
          content: null
      }

    },
    mutations: {
        setIsSyncedMessages(state, payload){
            state.isSyncedMessages = payload
        },
        setMemberMessagesDocs (state, payload) {
            state.memberMessagesDocs = payload
        },
        setGroupMessagesDocs (state, payload) {
            state.groupMessagesDocs = payload
        }, 
        setGroupOwnerMessagesDocs (state, payload) {
            state.groupOwnerMessagesDocs = payload
        },
        setLineMessagesDocs (state, payload) {
            state.lineMessagesDocs = payload
        },
        resetMessagesState(state){
            state.isSyncedMessages= false
            state.messagesortorder= 'desc'  
            state.memberMessagesDocs= []
            state.groupMessagesDocs= []
            state.groupOwnerMessagesDocs= []
            state.lineMessagesDocs= []       
        }        
    },
    actions: {
        addMemberMessage ({dispatch, commit}, payload) {
            //one-on-one 'memberchat' updates
            console.log('inside addMemberMessage')   
            return new Promise((resolve, reject) => {  
                commit('setLoading', true)   
                var docRef = firebase.firestore().collection(this.getters.org).doc(payload.chatid)
                docRef.get()
                .then(docSnapshot => {
                    if (docSnapshot.exists) { 
                        console.log('addMemberMessage updating existing')                      
                        docRef.update({datelastmessage: payload.message.datecreated, lastmessage: payload.message.content, lastmessageauthorid : payload.message.authorid, lastmessageauthorname : payload.message.authorname, lastmessageauthoravatar : payload.message.authoravatar, messages: firebase.firestore.FieldValue.arrayUnion(payload.message)})
                        commit('setLoading', false)   
                        event('chat', 'messagesent', 'MemberMessage' ) //GA EVENT
                        resolve('success')                        
                    }else{
                        console.log('addMemberMessage creating new existing')                      
                        var tmpchatdoc = this.getters.messagesdocTemplate
                        tmpchatdoc.ismemberchat = true
                        tmpchatdoc.chatid = payload.chatid
                        tmpchatdoc.chapter = payload.chapter
                        tmpchatdoc.org = payload.org
                        tmpchatdoc.chatname = payload.chatname
                        tmpchatdoc.participants = payload.participants
                        tmpchatdoc.participantnames = payload.participantnames
                        for (var i = 0; i < tmpchatdoc.participants.length; i++) { 
                            var pid = tmpchatdoc.participants[i]
                            tmpchatdoc[pid]=true
                        }
                        tmpchatdoc.messages = new Array()
                        tmpchatdoc.messages.push(payload.message)
                        tmpchatdoc.datelastmessage = payload.message.datecreated 
                        tmpchatdoc.lastmessage = payload.message.content
                        tmpchatdoc.lastmessageauthorid = payload.message.authorid
                        tmpchatdoc.lastmessageauthorname = payload.message.authorname
                        firebase.firestore().collection(this.getters.org).doc(payload.chatid).set(
                            tmpchatdoc    
                        )
                        commit('setLoading', false)   
                        event('chat', 'messagesent', 'MemberMessage' ) //GA EVENT
                        resolve('success')   
                    }                    

        
                  })
                  .catch(err => {
                      console.error('addMemberMessage error ', err)
                    commit('setLoading', false)   
                    resolve('error')
                  })
                             
            })
        },
        addLineMessage ({dispatch, commit}, payload) {
            //one-on-one 'memberchat' updates
            return new Promise((resolve, reject) => {  
                commit('setLoading', true)   
                var docRef = firebase.firestore().collection(payload.org).doc(payload.chatid)
                docRef.get()
                .then(docSnapshot => {
                    if (docSnapshot.exists) {
                        docRef.update({datelastmessage: payload.message.datecreated, lastmessage: payload.message.content, lastmessageauthorid : payload.message.authorid, lastmessageauthorname : payload.message.authorname, lastmessageauthoravatar : payload.message.authoravatar, messages: firebase.firestore.FieldValue.arrayUnion(payload.message)})
                        commit('setLoading', false)   
                        event('chat', 'messagesent', 'LineMessage' ) //GA EVENT
                        resolve('success')                        
                    }else{
                        
                        var tmpchatdoc = this.getters.messagesdocTemplate
                        tmpchatdoc.islinechat = true
                        tmpchatdoc.chatid = payload.chatid
                        tmpchatdoc.chapter = payload.chapter
                        tmpchatdoc.org = payload.org
                        tmpchatdoc.chatname = payload.chatname
                        tmpchatdoc.participants = payload.participants
                        tmpchatdoc.participantnames = payload.participantnames
                        for (var i = 0; i < tmpchatdoc.participants.length; i++) { 
                            var pid = tmpchatdoc.participants[i]
                            tmpchatdoc[pid]=true
                        }
                        if(payload.message){
                            tmpchatdoc.messages = new Array()
                            tmpchatdoc.messages.push(payload.message)
                            tmpchatdoc.datelastmessage = payload.message.datecreated 
                            tmpchatdoc.lastmessage = payload.message.content
                            tmpchatdoc.lastmessageauthorid = payload.message.authorid
                            tmpchatdoc.lastmessageauthorname = payload.message.authorname
                        }
                        firebase.firestore().collection(this.getters.org).doc(payload.chatid).set(
                            tmpchatdoc    
                        )
                        event('chat', 'messagesent', 'LineMessage' ) //GA EVENT
                        commit('setLoading', false)   
                        resolve('success')   
                    }                    

        
                  })
                  .catch(err => {
                    commit('setLoading', false)   
                    resolve('error')
                  })
                             
            })
        },       
        addGroupMessage ({dispatch, commit}, payload) {            
            return new Promise((resolve, reject) => {  
                commit('setLoading', true)   
                var docRef = firebase.firestore().collection(payload.org).doc(payload.chatid)
                docRef.get()
                .then(docSnapshot => {
                    if (docSnapshot.exists) {
                        docRef.update({datelastmessage: payload.message.datecreated, lastmessage: payload.message.content, lastmessageauthorid : payload.message.authorid, lastmessageauthorname : payload.message.authorname, lastmessageauthoravatar : payload.message.authoravatar, messages: firebase.firestore.FieldValue.arrayUnion(payload.message)})
                        commit('setLoading', false)   
                        event('chat', 'messagesent', 'GroupMessage' ) //GA EVENT
                        resolve('success')                        
                    }else{
                        
                        var tmpchatdoc = payload
                        firebase.firestore().collection(tmpchatdoc.org).doc(tmpchatdoc.chatid).set(
                            tmpchatdoc    
                        )
                        event('chat', 'messagesent', 'GroupMessage' ) //GA EVENT
                        commit('setLoading', false)   
                        resolve('success')   
                    } 
                  })
                  .catch(err => {
                    commit('setLoading', false)   
                    resolve('failure')
                  })
                  resolve('success')            
            })
        },    
        addTask ({dispatch, commit}, payload) {            
            return new Promise((resolve, reject) => {  
                commit('setLoading', true)   
                var tmpchatid = payload.chatid
                var tmporg = payload.org
                var docRef = firebase.firestore().collection(tmporg).doc(tmpchatid)
                docRef.get()
                .then(docSnapshot => {
                    if (docSnapshot.exists) {
                        delete payload.chatid
                        delete payload.org
                        docRef.update({tasks: firebase.firestore.FieldValue.arrayUnion(payload)})
                        commit('setLoading', false)   
                        event('chat', 'taskadded', 'GroupMessage' ) //GA EVENT
                        resolve('success')                        
                    }else{
                        console.error('addTask - doc w/ chatid ' + payload.chatid + ' does not exist.')
                        commit('setLoading', false)   
                        resolve('failure')   
                    } 
                  })
                  .catch(err => {
                    commit('setLoading', false)   
                    resolve('failure')
                  })
                  resolve('success')            
            })
        },    
        updateTasks ({dispatch, commit}, payload) {            
            return new Promise((resolve, reject) => {  
                commit('setLoading', true)   
                var tmpchatid = payload.chatid
                var tmporg = payload.org
                //console.log('tmpchatid, tmporg, payload',tmpchatid,tmporg, payload)
                var docRef = firebase.firestore().collection(tmporg).doc(tmpchatid)
                docRef.get()
                .then(docSnapshot => {
                    if (docSnapshot.exists) {
                        try{
                            delete payload.chatid
                            delete payload.org
                        }catch(e){
                            console.warn(e)
                        }
                        //console.log('updateTasks updating db')
                        docRef.update({tasks: payload.tasks})
                        commit('setLoading', false)   
                        event('chat', 'updateTask', 'GroupMessage' ) //GA EVENT
                        resolve('success')                        
                    }else{
                        console.error('updateTask - doc w/ chatid ' + payload.chatid + ' does not exist.')
                        commit('setLoading', false)   
                        resolve('failure')   
                    } 
                  })
                  .catch(err => {
                    console.error('error updateTask - ', err)
                    commit('setLoading', false)   
                    resolve('failure')
                  })
                  resolve('success')            
            })
        },     
        updateParticipants ({dispatch, commit}, payload) {            
            return new Promise((resolve, reject) => {  
                commit('setLoading', true)   
                var tmpchatid = payload.chatid
                var tmporg = payload.org
                console.log('tmpchatid, tmporg, payload',tmpchatid,tmporg, payload)
                var docRef = firebase.firestore().collection(tmporg).doc(tmpchatid)
                docRef.get()
                .then(docSnapshot => {
                    if (docSnapshot.exists) {
                        try{
                            delete payload.chatid
                            delete payload.org
                        }catch(e){
                            console.warn(e)
                        }
                        console.log('updateParticipants updating db')
                        docRef.update({participantnames: payload.participantnames, participants: payload.participants})
                        commit('setLoading', false)   
                        event('chat', 'updateParticipants', 'GroupMessage' ) //GA EVENT
                        resolve('success')                        
                    }else{
                        console.error('updateParticipants - doc w/ chatid ' + payload.chatid + ' does not exist.')
                        commit('setLoading', false)   
                        resolve('failure')   
                    } 
                  })
                  .catch(err => {
                    console.error('error updateParticipants - ', err)
                    commit('setLoading', false)   
                    resolve('failure')
                  })
                  resolve('success')            
            })
        },                      
        initMessageSynch({dispatch, commit}, payload) {
            //LOAD AUTHENTICATED MEMBERS (USER one-on-one) CHATS TO THE STORE
            commit('setLoading', true)
            var pathMemberChats = payload.org + '/chat_member/' + payload.chapter 
            const userMemberChatCollection = firebase.firestore().collection(pathMemberChats).where('ismemberchat', '==', true).where('chapter', '==', payload.chapter).where(payload.userid, '==', true)
            userMemberChatCollection
            .onSnapshot((userMemberChatsRef) => {
              const tmpChats = []
              userMemberChatsRef.forEach((doc) => {
                const tmpChat = doc.data()
                tmpChat.id = doc.id
                if(tmpChat.datelastmessage){
                    tmpChat.datelastmessage = moment(tmpChat.datelastmessage).format(DATEFORMAT)
                }
                //sort doc messages descending prior to loading them in the doc array store
                if(this.getters.messagesortorder==='desc'){
                    var tmpmessages = tmpChat.messages
                    if(tmpmessages && tmpmessages.length && tmpmessages.length>0){
                        tmpChat.messages = tmpmessages.sort(function (a,b){ return b.datecreated - a.datecreated})
                        tmpChat.messages = tmpChat.messages.map(m =>{
                            m.datecreated = moment(m.datecreated).format(DATEFORMAT)
                            return m
                        })                        
                    }
                    var tmptasks = tmpChat.tasks
                    if(tmptasks && tmptasks.length && tmptasks.length>0){
                        tmpChat.tasks = tmpChat.tasks.map(t=>{
                            if(t.datecreated){
                                t.datecreated = moment(t.datecreated.seconds).format(DATEFORMAT)
                            }
                            if(t.laststatusdate){
                                t.laststatusdate = moment(t.laststatusdate.seconds).format(DATEFORMAT)
                            }

                            if(t.comments && t.comments.length && t.comments.length>0){
                                t.comments .forEach((part, index, theArray)=>{
                                    theArray[index].datecreated =  moment(theArray[index].datecreated.seconds).format(DATEFORMAT)
                                })
                            }
                            return t
                        })
                    }
                }
                tmpChats.push(tmpChat);
              })
              commit('setMemberMessagesDocs', tmpChats)
            })
            commit('addSnapshotlistener', userMemberChatCollection)

            var pathGroupChats = payload.org + '/chat_group/' + payload.chapter 
            //LOAD AUTHENTICATED MEMBER'S (GROUP) CHATS TO THE STORE [PARTICIPATING AND OWNER]
            const userGroupChatCollection = firebase.firestore().collection(pathGroupChats).where('isgroupchat', '==', true).where('chapter', '==', payload.chapter).where(payload.userid, '==', true)
            userGroupChatCollection
            .onSnapshot((userGroupChatsRef) => {
              var tmpUserGroupChats = []
              var tmpUserGroupOwnerChats = []
              userGroupChatsRef.forEach((doc) => {
                var doesOwn = false
                const tmpChat = doc.data()
                tmpChat.id = doc.id //dump thing to do, scared to change
                if(tmpChat.datelastmessage){
                    tmpChat.datelastmessage = moment(tmpChat.datelastmessage).format(DATEFORMAT)
                }

                //sort doc messages descending prior to loading them in the doc array store
                if(this.getters.messagesortorder==='desc'){
                    var tmpmessages = tmpChat.messages
                    if(tmpmessages && tmpmessages.length && tmpmessages.length>0){
                        tmpChat.messages = tmpmessages.sort(function (a,b){ return b.datecreated - a.datecreated})
                        tmpChat.messages = tmpChat.messages.map(m =>{
                            m.datecreated = moment(m.datecreated).format(DATEFORMAT)
                            return m
                        })

                    }
                    var tmptasks = tmpChat.tasks
                    if(tmptasks && tmptasks.length && tmptasks.length>0){
                        tmpChat.tasks = tmpChat.tasks.map(t=>{
                            if(t.datecreated){
                                t.datecreated = moment(t.datecreated.seconds).format(DATEFORMAT)
                            }
                            if(t.laststatusdate){
                                t.laststatusdate = moment(t.laststatusdate.seconds).format(DATEFORMAT)
                            }

                            if(t.comments && t.comments.length && t.comments.length>0){
                                t.comments .forEach((part, index, theArray)=>{
                                    theArray[index].datecreated =  moment(theArray[index].datecreated.seconds).format(DATEFORMAT)
                                })
                            }
                            return t
                        })
                    }                    
                }             
                if(tmpChat.ownerid && tmpChat.ownerid === payload.userid){
                    tmpUserGroupOwnerChats.push(tmpChat)
                }else{
                    tmpUserGroupChats.push(tmpChat)
                }                   
                
              })
              commit('setGroupMessagesDocs', tmpUserGroupChats)
              //tmpUserGroupOwnerChats = tmpUserGroupChats.filter(function(obj){ return obj.ownerid===payload.userid}) //handled above by checking ownerid property
              commit('setGroupOwnerMessagesDocs', tmpUserGroupOwnerChats)
            })
            commit('addSnapshotlistener', userGroupChatCollection)

            var pathLineChats = payload.org + '/chat_line/' + payload.chapter
            //LOAD AUTHENTICATED MEMBER'S (LINE) CHATS TO THE STORE
            const lineChatCollection = firebase.firestore().collection(pathLineChats).where('islinechat', '==', true).where('chapter', '==', payload.chapter).where(payload.lineid, '==', true)
            lineChatCollection
            .onSnapshot((lineChatsRef) => {
              var tmpLineChats = []
              var tmpUserGroupOwnerChats = []
              lineChatsRef.forEach((doc) => {
                const tmpChat = doc.data()
                tmpChat.id = doc.id
                if(tmpChat.datelastmessage){
                    tmpChat.datelastmessage = moment(tmpChat.datelastmessage).format(DATEFORMAT)
                }
                //sort doc messages descending prior to loading them in the doc array store
                if(this.getters.messagesortorder==='desc'){
                    var tmpmessages = tmpChat.messages
                    if(tmpmessages && tmpmessages.length && tmpmessages.length>0){
                        tmpChat.messages = tmpmessages.sort(function (a,b){ return b.datecreated - a.datecreated})
                        tmpChat.messages = tmpChat.messages.map(m =>{
                            m.datecreated = moment(m.datecreated).format(DATEFORMAT)
                            return m
                        })                        
                    }
                    var tmptasks = tmpChat.tasks
                    if(tmptasks && tmptasks.length && tmptasks.length>0){
                        tmpChat.tasks = tmpChat.tasks.map(t=>{
                            if(t.datecreated){
                                t.datecreated = moment(t.datecreated.seconds).format(DATEFORMAT)
                            }
                            if(t.laststatusdate){
                                t.laststatusdate = moment(t.laststatusdate.seconds).format(DATEFORMAT)
                            }

                            if(t.comments && t.comments.length && t.comments.length>0){
                                t.comments .forEach((part, index, theArray)=>{
                                    theArray[index].datecreated =  moment(theArray[index].datecreated.seconds).format(DATEFORMAT)
                                })
                            }
                            return t
                        })
                    }                    
                }                
                tmpLineChats.push(tmpChat)
              })
              commit('setLineMessagesDocs', tmpLineChats)
              

              //CREATE A DEFAULT (LINE) CHAT IF DNE
              if(tmpLineChats.length===0){
                var tmppayload = new Object()
                tmppayload.org = payload.org
                //tmppayload.chatid = payload.org + '_' + payload.chapter + '_chat_line_' + payload.lineid
                tmppayload.chatid = 'chat_line/' + payload.chapter + '/' + payload.lineid
                tmppayload.chapter = payload.chapter
                tmppayload.chatname = 'Line Chat ID: ' + payload.lineid
                tmppayload.participants = new Array ()
                tmppayload.participants.push(payload.lineid)
                tmppayload.participantnames =  new Array ()
                tmppayload.participantnames.push(payload.lineid)
                dispatch('addLineMessage',tmppayload)
              }
              
              
            })
            commit('addSnapshotlistener', lineChatCollection)            

            commit('setLoading', false)    
            commit('setIsSyncedMessages', true)          
        }
    },
    getters: {
        messagesdocTemplate (state) {
            return state.messagesdocTemplate
        },
        messageTemplate (state) {
            return state.messageTemplate
        },
        memberMessagesDocs (state) {
            return state.memberMessagesDocs
        },
        groupMessagesDocs (state) {
            return state.groupMessagesDocs
        },
        groupOwnerMessagesDocs (state) {
            return state.groupOwnerMessagesDocs
        },
        lineMessagesDocs (state) {
            return state.lineMessagesDocs
        },
        messagesortorder (state) {
            return state.messagesortorder
        },
        isSyncedMessages (state){
            return state.isSyncedMessages
        }                       
    }
  }